module.exports = __webpack_public_path__ + "static/stonecreative-logo.b390ac75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/stonecreative-logo.png
// module id = 376
// module chunks = 114276838955818